import { SET_GENERATE_SESSION_PARAMS, VideoVerificationActions } from '../actions/video-verification-actions'
import { IVideoVerificationState } from '../types'


export const videoVerificationInitialState: IVideoVerificationState = {
   sessionId: '',
   documentId: '',
   videoVerificationUrl: '',
}

export function videoVerificationReducer(state: IVideoVerificationState = videoVerificationInitialState, action: VideoVerificationActions) {
   switch (action.type) {
     
     case SET_GENERATE_SESSION_PARAMS: {
       return {
         sessionId: action.payload.sessionId,
         documentId: action.payload.documentId,
         videoVerificationUrl: action.payload.videoVerificationUrl,
       }
     }
     default: {
       return state
     }
   }
 }
 